import React, { useState, useEffect, forwardRef } from "react";

const ToggleSwitch = forwardRef(function ToggleSwitch(
  {
    isSmall = false,
    cssClass = "",
    value,
    onChange,
    name,
    defaultChecked = false,
    disabled = false,
    onBlur,
  },
  ref
) {
  const [isOn, setIsOn] = useState(defaultChecked);

  useEffect(() => {
    if (value !== undefined) {
      setIsOn(value);
    }
  }, [value]);

  const handleToggle = () => {
    if (disabled) return; // Prevent toggling if disabled

    const newState = !isOn;
    setIsOn(newState);

    if (onChange) {
      onChange(newState);
    }
  };

  const toggleClass = `transition-colors duration-300 ${
    isOn ? "bg-[#12999D]" : "bg-[#AB4571]"
  } ${disabled ? "bg-opacity-50 cursor-not-allowed" : ""}`;

  const knobClass = `transition-transform duration-300 transform ${
    isOn
      ? isSmall
        ? "translate-x-[20px] bg-[#00D1B7]"
        : "translate-x-[28px] bg-[#00D1B7]"
      : "bg-[#FF456E] translate-x-0"
  } ${isSmall ? "w-4 h-4" : "w-6 h-6"} border border-[#2D4575] rounded-full shadow-md ${
    disabled ? "opacity-50" : ""
  }`;

  return (
    <button
      ref={ref}
      name={name}
      onBlur={onBlur}
      aria-pressed={isOn}
      type="button"
      disabled={disabled}
      onClick={handleToggle}
      className={`${toggleClass} ${
        isSmall ? "w-9 h-4" : "w-12 h-6"
      } flex items-center rounded-full cursor-pointer focus:outline-none ${cssClass}`}
      style={disabled ? { cursor: "not-allowed" } : {}}
    >
      <div className={knobClass} />
    </button>
  );
});

export default ToggleSwitch;
